export default __webpack_public_path__ + "static/media/You_Failed_3_2.9570b442.png";